export default {
  useFixtures: false,
  ezLogin: false,
  yellowBox: true,
  reduxLogging: true,
  includeExamples: true,
  useReactotron: process.env.NODE_ENV === "development",
};
